import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Root index entry. Captures ?ref=CODE from links shared by sponsors and routes
 * the visitor sensibly:
 *  - logged-in users → /dashboard
 *  - guests with ?ref=CODE → /registracija?ref=CODE (preserves sponsor attribution)
 *  - guests without ref   → /ciklusi (public landing)
 */
export default function RootRedirect() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-[#22ff77] font-display tracking-widest text-sm">
        Učitavanje...
      </div>
    );
  }

  if (user) return <Navigate to="/dashboard" replace />;

  const params = new URLSearchParams(location.search);
  const ref = params.get("ref");
  if (ref) {
    return <Navigate to={`/registracija?ref=${encodeURIComponent(ref)}`} replace />;
  }
  return <Navigate to="/prijava" replace />;
}
